import {tablePoints} from "./features/tablePoints";
import {tablePointsJson} from "./utils/types";

export default () => {
    const visitSwitch = document.querySelector('#activateVisit_switch') as HTMLInputElement

    visitSwitch?.addEventListener('change', function () {
        const pathActivateVisit = visitSwitch.getAttribute('data-visit')

        if (!pathActivateVisit) return

        let data = new FormData();
        data.append("isChecked", String(this.checked))
        fetch(pathActivateVisit,
            {
                method: "POST",
                body: data
            })
            .then(response => response.json())
            .then((data: tablePointsJson) => {
                tablePoints(data)
            })
            .catch(error => {
                console.error("Erreur lors de la requête:", error);
            });

        const points = document.querySelector('.visitProject .testimony__pts span') as HTMLSpanElement

        if (points) {
            this.checked ? points.innerText = points.getAttribute('data-max') || '25' : points.innerText = points.getAttribute('data-min') || '0'
        }

        const forms = document.getElementsByClassName('form-event')

        for (let i = 0; i < forms.length; i++) {
            if (this.checked) {
                forms[i].classList.remove('hidden')
            } else {
                forms[i].classList.add('hidden')
            }
        }

        const formsDisabled = document.getElementsByClassName('form-disabled')

        for (let i = 0; i < formsDisabled.length; i++) {
            if (this.checked) {
                formsDisabled[i].classList.add('hidden')
            } else {
                formsDisabled[i].classList.remove('hidden')
            }
        }

        const visitPage = document.querySelector('.visit')

        if (visitPage) {
            visitPage.querySelector('.visit__card')?.classList.toggle('desactivate')
        }
    })
}
